
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20.14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 4451"}},[_c('path',{attrs:{"data-name":"ic add alarm 24px","d":"M5.88 1.53L4.6 0 0 3.85l1.29 1.53zM20 3.86L15.4 0l-1.29 1.53 4.6 3.86zM10 2.14a9 9 0 109 9 9 9 0 00-9-8.999zm0 16a6.995 6.995 0 11.01 0z","fill":"#fff"}}),_c('g',{attrs:{"data-name":"Group 4450","fill":"#f36"}},[_c('path',{attrs:{"data-name":"Rectangle 3725","d":"M9 6.14h2v6H9z"}}),_c('path',{attrs:{"data-name":"Rectangle 3726","d":"M9 14.14h2v2H9z"}})])])])
          )
        }
      }
    